import React, { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { ProgressBar, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { useHeaderHeight } from 'hooks';
const Header = ({ title, hasAddress, isUnderReview }) => {
    const colors = useColors();
    const headerHeight = useHeaderHeight();
    const progress = useMemo(() => {
        if (isUnderReview) {
            return {
                step: 3,
                position: 66,
            };
        }
        if (hasAddress) {
            return {
                step: 2,
                position: 33,
            };
        }
        return {
            step: 1,
            position: 0,
        };
    }, [hasAddress, isUnderReview]);
    return (<View style={[styles.header, { paddingTop: headerHeight }]}>
      <Spacer h={16}/>
      <Text Text-24>{title}</Text>
      <Spacer h={16}/>
      <View style={styles.progressContainer}>
        <View style={styles.progressView}>
          <ProgressBar position={progress.position} barBackgroundColor={colors.background.brandLight} colors={[colors.elements.brand, colors.elements.brand]}/>
        </View>
        <Spacer w={16}/>
        <View style={styles.stepsContainer}>
          <Text Text-14 OnBrand>
            {progress.step}/3
          </Text>
        </View>
      </View>
    </View>);
};
export default memo(Header);
const styles = StyleSheet.create({
    header: {
        paddingBottom: rem(16),
        paddingHorizontal: rem(16),
    },
    progressContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    stepsContainer: {
        width: 28,
        alignItems: 'flex-end',
    },
    progressView: {
        flex: 1,
        justifyContent: 'center',
    },
});
